<mat-drawer-container class="example-container" autosize>
  <mat-drawer #drawer [opened]="true" [disableClose]="false" class="example-sidenav" [mode]="drawerMode">
    <!-- <div class="close-menu">
      <img src="../assets/icons/menu-white.svg" class="menu-icon" width="28" alt="111" (click)="drawer.toggle()" />
    </div> -->
    <div class="profile">
      <div>
        <img *ngIf="userAvatar" class="profile-img" [src]="userAvatar" />
        <img *ngIf="!userAvatar" class="profile-img" src="../assets/icons/default-user-icon-profile.png" />
      </div>

      <p>CEC ID: {{ ' ' + cecid }}</p>

      <mat-menu #menu="matMenu"> </mat-menu>
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title class="profile-name">
              {{ userName }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <button class="prolile-menu" mat-menu-item [routerLink]="['/minha-conta']" (click)="closeDrawer()">
            <span>Alterar meus dados</span>
          </button>
          <button class="prolile-menu" mat-menu-item [routerLink]="['/changePassword']" (click)="closeDrawer()">
            <span>Alterar senha</span>
          </button>
          <button class="prolile-menu" mat-menu-item (click)="logout()" style="color: #cd0505" (click)="closeDrawer()">
            sair &nbsp;<img class="exit-icon" src="../assets/icons/exit.svg" />
          </button>
        </mat-expansion-panel>
      </mat-accordion>

      <div></div>
    </div>
    <mat-divider></mat-divider>
    <div class="menu-list" id="menu">
      <div
        class="menu-item"
        id="111"
        (click)="closeDrawer()"
        [routerLink]="['/dashboard']"
        [routerLinkActive]="['menu-item-active']"
      >
        <img src="../assets/icons/home.svg" color="#000" class="menu-icon" />
        <div class="menu-title">
          <p>home</p>
        </div>
      </div>

      <div
        *ngFor="let router of routers"
        #link
        class="menu-item"
        [routerLink]="[router.name]"
        (click)="closeDrawer()"
        [routerLinkActive]="['menu-item-active']"
      >
        <span [class]="'icon ' + router.icon"></span>
        <p>{{ router.name }}</p>
      </div>
    </div>
  </mat-drawer>
  <app-toolbar [drawerRefer]="drawer"></app-toolbar>
  <div class="container">
    <router-outlet> </router-outlet>
  </div>
</mat-drawer-container>
